import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface CellSummaryWrapperProps {
  isSelected?: boolean;
}

/*
 * Style.
 */

interface SummaryStyleProps {
  $isSelected?: boolean;
}

const StyledSummaryDiv = styled.div<SummaryStyleProps>`
  color: ${(p) => (p.$isSelected ? p.theme.alphas.white50 : p.theme.palette.blue.shade40)};
  ${ellipsis()};

  & > strong {
    font-weight: ${fontWeights.semibold};
  }
`;

/*
 * Component.
 */

export const CellSummaryWrapper: FC<CellSummaryWrapperProps> = (props) => (
  <StyledSummaryDiv $isSelected={props.isSelected}>{props.children}</StyledSummaryDiv>
);
